import {clone} from 'ramda'

/**
 * A function that receives Cognito request and sanitizes it.
 * @param request the request that is received in the Cognito error trigger
 */
export const sanitizeCognitoRequestDetails = request => {
  const requestCopy = clone(request || {})

  if (requestCopy?.arg?.user) {
    const {user} = requestCopy.arg
    delete user.username
    delete user.Session
    delete user?.challengeParam?.phone_number
    delete user.userDataKey
    delete requestCopy.arg?.phoneNumber
  }

  return requestCopy
}
